import ContributorBusinessCardModal, {
  CONTRIBUTOR_BUSINESS_CARD_MODAL,
} from './modal';

export { CONTRIBUTOR_BUSINESS_CARD_MODAL };
export default ContributorBusinessCardModal;
